import React, { ChangeEvent, useEffect } from 'react';
import { useVesselStore } from '../../context/VesselContext';
import SelectVesselComponent from '../../components/ui/select-vessel/SelectVessel';
import { SelectOption } from '../../types/ViewModel/SelectOption';
import {
    IncludeInactiveVesselsWrapper,
    SelectVesselPageContentWrapper,
    SelectVesselTextWrapper,
    SelectVesselWrapper,
    Wrapper,
} from './SelectVessel.styles';
import { Vessel } from '../../types/ViewModel/Vessel/Vessel';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../context/AuthContext';
import { RoleTypeEnum } from '../../enums/roleTypeEnum';
import { PrimaryButton } from '../../styles/button.style';
import useAppFeature from '../../app/useAppFeature';
import { AppFeatureEnum } from '../../enums/appFeatureEnum';

const SelectVesselPage: React.FC = () => {
    const { selectedVessel, vesselList, filteredVesselList, setFilteredVesselList, includeInactiveVessels, setIncludeInactiveVessels } =
        useVesselStore();
    const navigate = useNavigate();
    const { role, loggedInUser } = useAuthStore();
    const { isFeatureEnabled } = useAppFeature();

    useEffect(() => {
        if (!selectedVessel && vesselList && vesselList.length === 1 && role && role.roleType === RoleTypeEnum.ShipUser) {
            const vessel = vesselList[0];
            updateQuery(vessel);
        }
    }, [vesselList, role]);

    const toggleIncludeInactiveShips = (event: ChangeEvent<HTMLInputElement>) => {
        setIncludeInactiveVessels(event.target.checked);
        if (event.target.checked) {
            setFilteredVesselList(vesselList);
        } else {
            setFilteredVesselList(vesselList.filter((o) => o.isActive));
        }
    };

    const updateQuery = (vessel: Vessel) => {
        const params = new URLSearchParams({ imoNumber: vessel.imoNumber.toString() });
        if (loggedInUser?.appAccessToken) {
            params.set('appAccessToken', loggedInUser.appAccessToken);
        }
        navigate({
            pathname: '/report-events',
            search: '?' + params.toString(),
        });
    };

    const handleSelectVesselChange = (e: SelectOption) => {
        const selVessel = vesselList.find((v) => v.imoNumber === +e.value);
        if (selVessel) {
            updateQuery(selVessel);
        }
    };

    return (
        <SelectVesselPageContentWrapper>
            <Wrapper>
                <SelectVesselTextWrapper>Select vessel</SelectVesselTextWrapper>
                <SelectVesselWrapper>
                    <SelectVesselComponent
                        onChange={handleSelectVesselChange}
                        vesselList={filteredVesselList}
                        selectedVessel={selectedVessel}
                        width="200px"
                    ></SelectVesselComponent>
                </SelectVesselWrapper>
                <IncludeInactiveVesselsWrapper>
                    <input type="checkbox" onChange={toggleIncludeInactiveShips} checked={includeInactiveVessels} />
                    Include inactive vessels
                </IncludeInactiveVesselsWrapper>
            </Wrapper>
            {role &&
                (role.roleType == RoleTypeEnum.Admin || role.roleType == RoleTypeEnum.FleetPerformanceAnalyst) &&
                isFeatureEnabled({ featureEnum: AppFeatureEnum.Verification, date: new Date(), role: role.roleType }) && (
                    <PrimaryButton
                        onClick={() =>
                            navigate({
                                pathname: '/verification',
                            })
                        }
                    >
                        Verification
                    </PrimaryButton>
                )}
        </SelectVesselPageContentWrapper>
    );
};

export default SelectVesselPage;
